// Fonts parameters
const FONT = Object.freeze({
    EAGER: [
        { family: 'F37Bolton', style: 'normal', weight: '400' },
        { family: 'F37Bolton', style: 'normal', weight: '700' }
    ]
});

export { FONT };
